import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';
import UpdateProfile from '../pages/updateProfile'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'',isUpdating:false,	viewProfile:true,LID:localStorage.getItem('tokens'),profileinfo:[]};		
		this.handleClick=this.handleClick.bind(this);		
		this.handleProfile=this.handleProfile.bind(this);
	}
	componentDidMount() {	
		const para={LID:this.state.LID}		
		axios.post(process.env.REACT_APP_API_ENV+'api/userinformation.php',para)
			.then(result => {					
				this.setState({profileinfo:result.data})				
			})							
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	handleClick(){				
		this.setState(prevState=>({isUpdating: !prevState.isUpdating}))		
		this.setState(prevState=>({viewProfile: !prevState.viewProfile}))		
	}	
	handleProfile(){				
		this.setState(prevState=>({viewProfile: !prevState.viewProfile}))			
		this.setState({isUpdating:false})		
	}
	render() {		
		return(
			<div id="content">			
				<CommonHeader titles="Profile"/>
				<h2 style={{textAlign:'center'}}>{this.state.CompName + ' welcome ' + this.state.profileinfo[1]}</h2><br/>
				<div style={{textAlign:'center'}}>
				<button onClick={this.handleProfile}>{this.state.viewProfile ? "View Profile Now":"View Profile ?"}</button>&nbsp;&nbsp;
				<button onClick={this.handleClick}>{this.state.isUpdating ? "Updating  Profile Now": "Update Your Profile?"}</button><br/><br/>
				</div>
				{(()=>{if(this.state.viewProfile === true) {return (<div>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Name:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[1]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>SIN:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[2]}</label><br/>					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Gender:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[3]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Birthday:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[4]}</label><br/>					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Address:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[5]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>City:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[6]}</label><br/>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Province:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[7]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Post Code:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[8]}</label><br/>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Date Move In:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[9]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Cell Phone:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[10]}</label><br/>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Employer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[32]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Employer Phone:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[33]}</label><br/>					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Date Started:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[34]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Job Status:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[35]}</label><br/>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Payment Type:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[36]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Payment Frequency:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[37]}</label><br/>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Each Pay Amount:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[40]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Is Direct Deposit:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[41]}</label><br/><br/>					
					<label>Please update your profile if anything changed, thanks for your cooperation!</label><br/><br/>					
				</div>)}})()}	
				{(()=>{if(this.state.isUpdating === true) {return (
					<UpdateProfile/>
				)}})()}			
			</div>
		)
	}
}

export default HomtContents